<template>
	<transition name="fade" mode="out-in">
		<div class="modal__wrap" @click.prevent="open = false" v-if="open">
			<div class="modal__content" @click.stop="">
				<div class="close" @click.prevent="open = false">
					&#10005;
				</div>
				<div class="modal__header">
					<slot name="header"></slot>
				</div>
				<div class="modal__body">
					<slot></slot>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
	export default {
		props: ['value'],
		data() {
			return {
				open: this.value
			};
		},
		watch: {
			open() {
				this.$emit('input', this.open);
			},
			value() {
				this.open = this.value;
			}
		}
	}
</script>